import React from "react";
import ConfigForm, { ConfigInput } from "components/Layout/ConfigForm";

interface BasicZoneConfigProps {
  handleZoneNameChange: (name: string) => void;
}
interface BasicZoneConfigState {
  name: string;
}

const DEFAULT_STATE: BasicZoneConfigState = {
  name: "",
};

export default function BasicGeoFenceConfig(props: BasicZoneConfigProps) {
  const [state, setState] = React.useState<BasicZoneConfigState>(DEFAULT_STATE);
  const handleZoneNameChange = (event: any) => {
    setState({ ...state, name: event.target.value });
    props.handleZoneNameChange(event.target.value);
  };
  const inputs: ConfigInput[] = [
    {
      title: "Zone Name",
      type: "text",
      onChange: handleZoneNameChange,
      xs: 12,
      sm: 6,
      id: "zoneName",
      value: state.name,
    },
  ];
  return <ConfigForm inputs={inputs}></ConfigForm>;
}
